setLiveAccessNextEventError